import { render, staticRenderFns } from "./CourseStatistic.vue?vue&type=template&id=71d48d94&scoped=true&"
import script from "./CourseStatistic.vue?vue&type=script&lang=js&"
export * from "./CourseStatistic.vue?vue&type=script&lang=js&"
import style0 from "./CourseStatistic.vue?vue&type=style&index=0&id=71d48d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d48d94",
  null
  
)

export default component.exports